import React from 'react';
import PropTypes from 'prop-types';
import { ImageBackground, View } from 'react-native';
import InfoPage from 'Pages/InfoPage';
import { t } from 'Locale/index';
import { Button } from 'LocalGluons/index';
import { getAssetImageUrl } from 'Utils/index';

import defaultStyles from './NoNetworkDialog.jss';

const NoNetworkDialog = ({ item, onClose, onBack, onRetry }) => (
    <ImageBackground
        style={defaultStyles.previewImage}
        source={{ uri: getAssetImageUrl(item, 'PREVIEW') }}
    >
        <InfoPage
            heading={t('COMMON.INFORMATION_MSG')}
            message={t('COMMON.NETWORK_DISCONNECTED_MSG')}
            mode="landscape"
            onClose={onClose}
        >
            <View style={defaultStyles.infoButtonsContainer}>
                <View style={defaultStyles.leftButtonContainer}>
                    <Button isSecondary title={t('COMMON.BACK')} onPress={onBack} />
                </View>
                <View>
                    <Button title={t('COMMON.RETRY')} onPress={onRetry} />
                </View>
            </View>
        </InfoPage>
    </ImageBackground>
);

NoNetworkDialog.propTypes = {
    item: PropTypes.shape({}).isRequired,
    onClose: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onRetry: PropTypes.func.isRequired
};

export default NoNetworkDialog;
